import React, { useState } from "react";
import { Typography, Button, Dialog, Box } from "@mui/material";
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

interface StateProps {
    render: (onClose: () => void) => React.ReactNode;
}

type ContextProps = (args: StateProps) => void;

export const ConfirmDialogContext = React.createContext<ContextProps>(() => { });

function ConfirmDialogProviderWithDescription({ children }: any) {
    const [open, setOpen] = useState(false);
    const [render, setRender] = useState<((onClose: () => void) => React.ReactNode) | null>(null);

    const handleClose = () => {
        setOpen(false);
    };

    const confirm: ContextProps = ({ render }) => {
        setRender(() => render);
        setOpen(true);
    };

    return (
        <ConfirmDialogContext.Provider value={confirm}>
            {children}
            <Dialog maxWidth="xs" fullWidth open={open} onClose={handleClose}>
                <Box p={2}>
                    <Typography
                        color="primary"
                        gutterBottom
                        variant="subtitle1"
                        display="flex"
                        gap={1}
                        alignItems="center"
                        justifyContent="center"
                    >
                        Warning <WarningAmberRoundedIcon color="secondary" fontSize="medium" />
                    </Typography>
                    <Box mt={2}>
                        {render && render(handleClose)}
                    </Box>
                </Box>
            </Dialog>
        </ConfirmDialogContext.Provider>
    );
}


export const useConfirm = () => React.useContext(ConfirmDialogContext);

export default ConfirmDialogProviderWithDescription;
